import React, { FC, memo } from 'react'
import { Dialog } from '@ucheba/ui/components/Dialog/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Field, Formik } from 'formik'
import HelpIcon from '@ucheba/ui/icons/icon__help.svg'
import { Checkbox } from '@ucheba/ui/components/Checkbox/desktop'
import { Tooltip } from '@ucheba/ui/components/Tooltip/desktop/Tooltip'
import styled from 'styled-components'
import Loader from '@ucheba/ui/components/Loader/desktop/Loader'
import { Form } from '@ucheba/ui/components/Form/desktop'
import { useInitialValues, useInputs, useSelectEgeDialog } from '../bll'
import SC from '../base/SelectEgeDialog.styles'
import SelectEgeDialogEge from './SelectEgeDialogEge'
import { ISelectEgeDialog } from '../types'

const { Input } = SC

const TooltipSC = styled(Tooltip)`
  display: inline-block;
`

const HelpIconST = styled(HelpIcon)`
  cursor: help;
  position: absolute;
  top: 4px;
  left: 4px;
`

const SelectEgeDialog: FC<ISelectEgeDialog> = (props) => {
  const {
    scrollY = false,
    open,
    onClose,
    onAfterSubmit,
    onBeforeSubmit,
    overflow = 'auto',
  } = props

  const { onSubmit, loading } = useSelectEgeDialog(open, onAfterSubmit, onBeforeSubmit)

  const initialValues = useInitialValues()

  const inputs = useInputs()

  if (!open) return <></>

  return (
    <Dialog
      open={open}
      scrollY={scrollY}
      spacing='xlarge'
      overflow={overflow}
      onClose={onClose}
    >
      <Heading h2='Оцените свои шансы' spacing='large' />

      <Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize>
        {(formikProps): JSX.Element => {
          return (
            <Form fillByProfile>
              {loading ? (
                <Loader />
              ) : (
                <>
                  <Grid justifyContent='space-between' spacing='small'>
                    <GridCol width='320px'>
                      <Text fontSize='h3' fontWeight='extrabold' lineHeight='h3'>
                        Баллы ЕГЭ
                      </Text>

                      <Spacing spacing='small' />

                      <Text>
                        Укажите баллы по всем предметам, которые вы сдали или собираетесь
                        сдавать (можно ожидаемые).
                      </Text>

                      <Spacing spacing='xlarge' />

                      <SelectEgeDialogEge
                        values={formikProps.values.egeList}
                        initialValues={initialValues}
                      />
                    </GridCol>

                    <GridCol width='280px'>
                      <Text fontSize='h3' fontWeight='extrabold' lineHeight='h3'>
                        Достижения
                      </Text>

                      <Spacing spacing='small' />

                      {inputs.map((achieve) => (
                        <React.Fragment key={achieve.id}>
                          <Input>
                            <Field
                              firstLetterUppercase
                              type='checkbox'
                              name='achievements'
                              value={String(achieve.id)}
                              label=''
                              as={Checkbox}
                            />
                            <Text html={false} firstLetterUppercase>
                              <span>{achieve.name}</span>

                              {achieve.tooltip && (
                                <TooltipSC
                                  width='320px'
                                  position='left-top'
                                  content={achieve.tooltip}
                                >
                                  <div style={{ position: 'relative', height: '20px' }}>
                                    <HelpIconST
                                      width='20px'
                                      height='20px'
                                      color='rgba(3,15,35,0.5)'
                                    />
                                  </div>
                                </TooltipSC>
                              )}
                            </Text>
                          </Input>

                          <Spacing spacing='medium' />
                        </React.Fragment>
                      ))}
                    </GridCol>
                  </Grid>

                  <Spacing spacing='xlarge' />

                  <Button color='blue' block type='submit' progress={loading}>
                    Оценить шансы на поступление
                  </Button>
                </>
              )}
            </Form>
          )
        }}
      </Formik>
    </Dialog>
  )
}

export default memo(SelectEgeDialog)
